import { GridRenderCellParams, GridColDef } from '@mui/x-data-grid-premium'
import { TableCell } from '@ketch-com/deck'
import { Box, Typography } from '@mui/material'

export const togglePurposeEnabledStateTableColumnsListColumns: GridColDef<[string, any]>[] = [
  {
    align: 'left',
    field: 'stack',
    headerAlign: 'left',
    headerName: 'Stack',
    sortable: false,
    flex: 1,
    renderCell: ({ row: warning }: GridRenderCellParams<[string, any]>) => (
      <TableCell padding="8px 0">
        <Typography variant="label">{warning?.[0]}</Typography>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'group',
    flex: 1,
    headerAlign: 'left',
    headerName: 'Group',
    sortable: false,
    renderCell: ({ row: warning }: GridRenderCellParams<[string, any]>) => {
      const renderedData = Object.entries(warning?.[1] || {}).map(([group]) => {
        if (group === 'stackWillBeDeleted') {
          return (
            <Box display="flex" key={group}>
              <Typography sx={{ color: 'chileanFire.main' }}>
                Stack will be deleted because there will be no groups with purposes remaining.
              </Typography>
            </Box>
          )
        } else {
          return (
            <Box display="flex" key={group}>
              <Typography>{group}</Typography>
            </Box>
          )
        }
      })
      return <TableCell>{renderedData}</TableCell>
    },
  },
]
